import React from 'react';
import { Skeleton } from '../../ui/skeleton';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../ui/table';

const TableLoadingSkeleton = ({ 
  rows = 5, 
  columns = 4,
  showHeader = true,
  showActions = false,
  className = ""
}) => {
  const columnCount = showActions ? columns + 1 : columns;
  
  return (
    <div className={`w-full ${className}`}>
      {showHeader && (
        <div className="mb-4 flex items-center justify-between">
          <Skeleton className="h-6 w-48" />
          <div className="flex gap-2">
            <Skeleton className="h-9 w-24" />
            <Skeleton className="h-9 w-24" />
          </div>
        </div>
      )}
      
      <div className="rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              {[...Array(columnCount)].map((_, index) => (
                <TableHead key={index}>
                  <Skeleton className="h-4 w-24" />
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {[...Array(rows)].map((_, rowIndex) => (
              <TableRow key={rowIndex}>
                {[...Array(columnCount)].map((_, colIndex) => (
                  <TableCell key={colIndex}>
                    {showActions && colIndex === columnCount - 1 ? (
                      <div className="flex gap-2">
                        <Skeleton className="h-8 w-8" />
                        <Skeleton className="h-8 w-8" />
                      </div>
                    ) : (
                      <Skeleton className={`h-4 ${colIndex === 0 ? 'w-32' : 'w-24'}`} />
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      
      {/* Pagination Skeleton */}
      <div className="mt-4 flex items-center justify-between">
        <Skeleton className="h-4 w-48" />
        <div className="flex gap-2">
          <Skeleton className="h-8 w-8" />
          <Skeleton className="h-8 w-8" />
          <Skeleton className="h-8 w-8" />
        </div>
      </div>
    </div>
  );
};

export default TableLoadingSkeleton;